import { cn } from '@/utilities/ui'

const Skeleton = ({ className, ...props }: React.ComponentProps<'div'>) => {
  return (
    <div
      data-slot="skeleton"
      className={cn('pointer-events-none animate-pulse rounded-md bg-muted', className)}
      {...props}
    />
  )
}

export { Skeleton }
